import { useFormContext } from 'react-hook-form';
import { useSnapshot } from 'valtio/react';

import { Button } from '@paid-ui/components/button';
import { EmailInput } from '@paid-ui/components/email-input';
import { FormControl, FormField, FormHelper, FormItem } from '@paid-ui/components/form';
import { Input } from '@paid-ui/components/input';

import { signUpManager } from '../../models';
import { InviteJoinReason, SignUpStep } from '../../models/enums';
import { useSendJoinEmail } from '../../mutations/send-join-email';

interface Props {
  disabled?: boolean;
}

export const StepEmployeeInviteDirector: React.FC<Props> = ({ disabled }) => {
  const form = useFormContext();
  const { currentStep } = useSnapshot(signUpManager);
  const { mutate, isLoading: isPending } = useSendJoinEmail();
  const inviterName = form.watch('inviterName');
  const inviteeEmail = form.watch('inviteeEmail');
  const isValid =
    Boolean(inviterName && inviteeEmail) &&
    !form.getFieldState('inviterName').invalid &&
    !form.getFieldState('inviteeEmail').invalid;

  const handleNext = () => {
    const { inviterName, inviteeEmail } = form.getValues();
    mutate({
      inviterName,
      inviteeEmail,
      inviteJoinReason: InviteJoinReason.EMPLOYEE_INVITE_DIRECTOR,
    });
  };

  if (currentStep !== SignUpStep.EMPLOYEE_INVITE_DIRECTOR) {
    return null;
  }

  return (
    <div className="space-y-9">
      <div className="space-y-3.5">
        <FormField
          name="inviterName"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input {...field} placeholder="Your name" autoComplete="off" disabled={disabled} />
              </FormControl>
              <FormHelper />
            </FormItem>
          )}
        />
        <FormField
          name="inviteeEmail"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <EmailInput
                  {...field}
                  placeholder="Enter owner's email"
                  autoComplete="off"
                  disabled={disabled}
                />
              </FormControl>
              <FormHelper />
            </FormItem>
          )}
        />
      </div>
      <Button
        variant="solid"
        className="h-[44px]"
        disabled={disabled || !isValid}
        loading={isPending}
        onClick={handleNext}
      >
        {isPending ? 'Sending...' : 'Invite owner to sign up'}
      </Button>
    </div>
  );
};
